'use client';

import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ChangeEventHandler, FocusEventHandler } from 'react';
import { CalculatorField } from './CalculatorField';
import { CalculatorOutlinedInput } from './CalculatorOutlinedInput';

const PERCENT_ADORNMENT = (
  <Typography variant="text" sx={{ color: 'neutral.main', fontWeight: 325 }}>
    %
  </Typography>
);

export const APY_FIELD_LABEL_SX: SxProps<Theme> = {
  overflow: { xs: 'visible', sm: 'hidden' },
  textOverflow: { xs: 'clip', sm: 'ellipsis' },
  whiteSpace: { xs: 'normal', sm: 'nowrap' },
};

export type ApyPercentCalculatorInputProps = {
  error?: string | null;
  fullWidth?: boolean;
  id: string;
  label?: string;
  onBlur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  value: string;
};

export function ApyPercentCalculatorInput({
  error,
  fullWidth = true,
  id,
  label = 'Annual percentage yield (APY)',
  onBlur,
  onChange,
  value,
}: ApyPercentCalculatorInputProps) {
  const hasError = Boolean(error);

  return (
    <CalculatorField error={error} htmlFor={id} label={label} labelSx={APY_FIELD_LABEL_SX}>
      <CalculatorOutlinedInput
        id={id}
        fullWidth={fullWidth}
        endAdornment={PERCENT_ADORNMENT}
        gap="mdUp"
        hasError={hasError}
        slotProps={{
          input: {
            inputMode: 'decimal',
            sx: { padding: 0 },
          },
        }}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
      />
    </CalculatorField>
  );
}
